<button
  type="button"
  class="{{ computedCssClass }}"
  [disabled]="isDisabled"
  (click)="onClicked()"
>
  {{ buttonText }}

  <i *ngIf="showIcon" class="{{ iconClass }}"></i>
</button>
